// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dl-dialog-filter__filter-boolean {
  display: flex;
  align-items: center;
  height: 40px;
}
.dl-dialog-filter__filter-boolean .radiobox__radio + .radiobox__radio {
  margin-left: 10px;
}`, "",{"version":3,"sources":["webpack://./src/ui/components/DialogFilter/BooleanFilter/BooleanFilter.scss"],"names":[],"mappings":"AACI;EACI,aAAA;EACA,mBAAA;EACA,YAAA;AAAR;AAEQ;EACI,iBAAA;AAAZ","sourcesContent":[".dl-dialog-filter__filter-boolean {\n  display: flex;\n  align-items: center;\n  height: 40px;\n}\n.dl-dialog-filter__filter-boolean .radiobox__radio + .radiobox__radio {\n  margin-left: 10px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
